module.exports = __webpack_public_path__ + "img/ico-tasks.c9a54a1.svg";